import { render, staticRenderFns } from "./MasterDataStatusAutocomplete.vue?vue&type=template&id=4a9a7760"
import script from "./MasterDataStatusAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./MasterDataStatusAutocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports